import { mandatory, nonMandatory } from '../storeFromRequestParamsValidation';

// TODO: add tests
export const createPathWithExtension = (path: string | undefined, extension: string | undefined) => {
  if (!path || !extension) {
    return null;
  }
  return `${path}.${extension}`;
};

export const createImage = (host: string, aspectRatio?:object) => (image: any) => {
    const path = mandatory(image.path, '');
    const fileExtension = mandatory(image.fileExtension, '');
    return {
        host: mandatory(host, ''),
        path: createPathWithExtension(path, fileExtension),
        credit: nonMandatory(image.credit),
        caption: nonMandatory(image.caption),
        description: nonMandatory(image.description),
        ...aspectRatio ? { aspectRatio } : {},
    };
};

export const createCoverVideo = (media: any) => {
    const type = mandatory(media.type, '');
    if (type === 'youtube') {
      return {
        html: mandatory(media.value.html, ''),
        mediaId: nonMandatory(media.value.mediaId),
        type,
      };
    }
    if (type === 'mmPlayer') {
        return {
            html: mandatory(media.value.html, ''),
            mediaId: mandatory(media.value.mediaId, ''),
            playerId: mandatory(media.value.playerId, ''),
            type,
        };
    }
    if (type === 'jw') {
      return {
        html: mandatory(media.value.html, ''),
        videoId: mandatory(media.value.videoId, ''),
        playerId: mandatory(media.value.playerId, ''),
        type,
      };
    }
    return null;
};

export const createAuthor = (author: any) => {
  return {
    name: mandatory(author.name, ''),
    link: nonMandatory(author.link),
  };
};

export const createAuthors = (hideOwner: boolean) => (authors: any) => {
  const additionalAuthors = nonMandatory(authors.additional);
  const owner = mandatory(authors.owner, null);
  return [
    ...((hideOwner || !owner) ? [] : [owner]),
    ...(additionalAuthors || []),
  ].map(createAuthor);
};

export const createArticles = (imagesHost: any) => (articles: Array<any>) => {
    return articles.map(article => {
        return {
            id: mandatory(article.id, ''),
            title: mandatory(article.title, ''),
            image: mandatory(article.cover.image.value, {}, createImage(imagesHost)),
            coverType: mandatory(article.coverType, ''),
            articleUrl: mandatory(article.articleUrl, ''),
            author: mandatory(article.author, '', createAuthor),
            createdAt: mandatory(article.createdAt, ''),
            updatedAt: mandatory(article.updatedAt, ''),
            featuredAt: mandatory(article.featuredAt, ''),
        };
    });
};
